import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { AppInjector } from '../services/set-app-injector';
import { ICommonModalData } from './common-modal.interface';
import { CommonModalDataService } from './common-modal-data.service';

declare const P4: any;

export class CommonModalModel {
  public modal$ = new BehaviorSubject<ICommonModalData>(null);
  public modalObs$ = this.modal$.asObservable();
  public modalData: ICommonModalData;
  public isVisible = false;

  private commonModalDataService: CommonModalDataService = AppInjector.get(CommonModalDataService);
  private keyPress: Subscription;

  constructor(
    _modalData: ICommonModalData,
    _actionOnClose: Function | Function[],
    _actionOnUserClose: Function | Function[],
  ) {
    this.setData(_modalData, _actionOnClose, _actionOnUserClose);
  }

  public setData(
    _modalData: ICommonModalData,
    _actionOnClose: Function | Function[],
    _actionOnUserClose: Function | Function[],
  ) {
    if (_actionOnClose) {
      _modalData._actionOnClose = _actionOnClose;
    }

    if (_actionOnUserClose) {
      _modalData._actionOnUserClose = _actionOnUserClose;
    }

    if (!_modalData.closeModal) {
      _modalData.closeModal = this.closeModal.bind(this);
    }

    this.isVisible = true;

    this.modalData = _modalData;

    this.keyPress = fromEvent(document, 'keydown').subscribe((event: KeyboardEvent) => {
      const keyCode = event.which || event.keyCode;

      if (keyCode == 27) {
        this.closeModal();
      }
    });

    this.publishData();
  }

  // user close action
  public closeModal(event?: Event): void {
    if (event) {
      event.preventDefault();
    }

    if (this.modalData._actionOnUserClose) {
      if (Array.isArray(this.modalData._actionOnUserClose)) {
        for (let i = 0; i < this.modalData._actionOnUserClose.length; i++) {
          this.modalData._actionOnUserClose[i]();
        }
      } else {
        this.modalData._actionOnUserClose();
      }
    }

    this.alwaysOnClose();

    this.destroyModal();
  }

  // script close action
  public removeModal(): void {
    this.alwaysOnClose();

    this.destroyModal();
  }

  private destroyModal(): void {
    this.isVisible = false;

    this.modal$.next(null);

    this.commonModalDataService.modals$.next(null);

    this.commonModalDataService.currentModalTemplateName = null;
  }

  private alwaysOnClose(): void {
    this.keyPress.unsubscribe();

    P4.modules.customModal.onClickClose();

    if (this.modalData._actionOnClose) {
      if (Array.isArray(this.modalData._actionOnClose)) {
        for (let i = 0; i < this.modalData._actionOnClose.length; i++) {
          this.modalData._actionOnClose[i]();
        }
      } else {
        this.modalData._actionOnClose();
      }
    }

    this.modalData.sourceElement && this.modalData.sourceElement.focus();
  }

  private publishData() {
    this.modal$.next(this.modalData);
  }
}
